export default "__VITE_ASSET__Dlq4GGG$__"